<template>
  <svg :width="size" :height="size" :viewBox="viewBox" xmlns="http://www.w3.org/2000/svg">
    <g>
      <path d="M40,40V2a2,2,0,0,0-2-2H2A2,2,0,0,0,0,2V40a2,2,0,0,0,2,2H38A2,2,0,0,0,40,40ZM2,2H38V27.59l-6.29-6.29a1,1,0,0,0-1.41,0L24,27.59l-7.21-7.21a1,1,0,0,0-1.41,0L2,33.74ZM2,40V36.57L16.08,22.49,33.59,40ZM25.41,29,31,23.41l7,7V40H36.41Z"/><path d="M46,6H42V8h4V46H10V44H8v2a2,2,0,0,0,2,2H46a2,2,0,0,0,2-2V8A2,2,0,0,0,46,6Z"/><path d="M22,18a6,6,0,1,0-6-6A6,6,0,0,0,22,18ZM22,8a4,4,0,1,1-4,4A4,4,0,0,1,22,8Z"/>
    </g>
  </svg>
</template>

<script>
export default {
  props: {
    size: {
      type: [Number, String],
      default: 48
    },
    box: {
      type: [Number, String],
      default: 48
    }
  },
  computed: {
    viewBox() {
      return `0 0 ${this.box} ${this.box}`
    }
  }
}
</script>